import styled from "styled-components";
import Box from "@mui/material/Box";
import { Link } from "react-router-dom";

export const BoxDrawer = styled(Box)`
  background-color: #1976d2;
  height: 100%;
`;
export const LinkDrawer = styled(Link)`
  text-decoration: none;
  color: white;
`;
